import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { HttpResponse } from '@ap/interface-generic';
import { ApValidationResultService } from '@ap/sign';

@Injectable({ providedIn: 'root' })
export class MijnHttpErrorService {
    private readonly noRedirectReasons = ['spending_limit_would_be_exceeded'];

    public constructor(private readonly validationResultService: ApValidationResultService) {}

    private static hasInsufficientPermission(response: HttpErrorResponse): boolean {
        return response.status === HttpResponse.FORBIDDEN;
    }

    private static needsToSign(response: HttpErrorResponse): boolean {
        return response.headers && response.headers.has('X-Authentication-Task-Id');
    }

    public shouldNavigateToError(response: HttpErrorResponse): boolean {
        return (
            MijnHttpErrorService.hasInsufficientPermission(response) &&
            !this.hasRecoverableLsmError(response) &&
            !MijnHttpErrorService.needsToSign(response) &&
            !this.isNoRedirectReason(response)
        );
    }

    private hasRecoverableLsmError(response: HttpErrorResponse): boolean {
        return response.error && this.validationResultService.isRecoverable(response.error.code);
    }

    private isNoRedirectReason(response: HttpErrorResponse): boolean {
        return (
            response.error &&
            this.noRedirectReasons.map((recoverableReason) => recoverableReason.toString()).indexOf(response.error.code) >= 0
        );
    }
}
